import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import RealityCheck from "components/UnifiedProject/RealityCheck/RealityCheck";
import RealityCheckContinuous from "components/Business/RealityCheck/RealityCheckContinuous";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : "new";

class RealityCheckContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getIsActiveOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.conditions.length === 0 &&
      optimized.activeSegment.job &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  render() {
    const {
      match,
      aibleViewType,
      isTableauMode,
      project,
      optimized,
      isContinuous,
      optimizer,
      segmentOptions,
      modelGroups,
      updateDrilldownValue
    } = this.props;

    if (isContinuous) {
      return <RealityCheckContinuous {...this.props} />;
    }

    return optimized === undefined ? <RealityCheck {...this.props} /> : <RealityCheck {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  const retId = ownProps.runId
    ? ownProps.runId
    : ownProps.isEditBlueprint
      ? ownProps.editBlueprintId
      : ownProps.optimized && ownProps.optimized.innerId !== undefined
        ? ownProps.optimized.innerId
        : id;

  return {
    updateTrueAction: (trueAction) => dispatch(setupReducer.updateTrueAction(retId, trueAction)),
    updateFalseAction: (falseAction) => dispatch(setupReducer.updateFalseAction(retId, falseAction)),
    updateOutcomeLabel: (outcomeLabel) => dispatch(setupReducer.updateOutcomeLabel(retId, outcomeLabel)),
    updateTransactionLabel: (transactionLabel) =>
      dispatch(setupReducer.updateTransactionLabel(retId, transactionLabel)),
    updateNotPursuedTransactionLabel: (notPursuedTransactionLabel) =>
      dispatch(setupReducer.updateNotPursuedTransactionLabel(retId, notPursuedTransactionLabel)),
    updateAdvancedRevenueLabel: (advRevenueLabel) =>
      dispatch(setupReducer.updateAdvancedRevenueLabel(retId, advRevenueLabel)),
    updateTruePositiveLabel: (truePositiveLabel) =>
      dispatch(setupReducer.updateTruePositiveLabel(retId, truePositiveLabel)),
    updateUnitType: (unitType) => dispatch(setupReducer.updateUnitType(retId, unitType)),

    updateMadLibs: (key, value) => dispatch(setupReducer.updateMadLibs(retId, key, value)),

    updatePursuedCount: (pursuedCount) => {
      dispatch(setupReducer.updatePursuedCount(retId, pursuedCount));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateNotPursuedCount: (notPursuedCount) => {
      dispatch(setupReducer.updateNotPursuedCount(retId, notPursuedCount));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updatePursuedRatio: (pursuedRatio) => {
      dispatch(setupReducer.updatePursuedRatio(retId, pursuedRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateNotPursuedRatio: (notPursuedRatio) => {
      dispatch(setupReducer.updateNotPursuedRatio(retId, notPursuedRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateBaselineConversionGain: (conversionGain) => {
      dispatch(setupReducer.updateBaselineConversionGain(retId, conversionGain));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },

    updateCountType: (countType) => dispatch(setupReducer.updateCountType(retId, countType)),

    updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(retId, timePeriod)),

    updateTryRatio: (tryRatio) => {
      dispatch(setupReducer.updateTryRatio(retId, tryRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id, true));
      }
    },

    updateConversionGain: (conversionGain) => {
      dispatch(setupReducer.updateConversionGain(retId, conversionGain, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionCost: (conversionCost) => {
      dispatch(setupReducer.updateConversionCost(retId, conversionCost, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionSaved: (conversionSaved) => {
      dispatch(setupReducer.updateConversionSaved(retId, conversionSaved, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionMissed: (conversionMissed) => {
      dispatch(setupReducer.updateConversionMissed(retId, conversionMissed, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },

    updateTotal: (total) => {
      dispatch(setupReducer.updateScaledTotal(ownProps.id, retId, total));
    },

    updateShowBusiness: (showBusiness) => dispatch(setupReducer.updateShowBusiness(retId, showBusiness)),
    updateShowImpact: (showImpact) => dispatch(setupReducer.updateShowImpact(retId, showImpact)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBudgetRange: (budgetRange) => {
      dispatch(setupReducer.updateBudgetRange(retId, id, budgetRange));
    },

    updateExpectedCountContinuous: (continuousCount) => {
      dispatch(setupReducer.updateIsRealityHammer(retId, true));
      dispatch(setupReducer.updateExpectedCountContinuous(retId, continuousCount));
    },
    updateExpectedValueContinuous: (continuousAveragePrice) => {
      dispatch(setupReducer.updateIsRealityHammer(retId, true));
      dispatch(setupReducer.updateExpectedValueContinuous(retId, continuousAveragePrice));
    },

    updateBaselineCountContinuous: (continuousCount) => {
      dispatch(setupReducer.updateBaselineCountContinuous(retId, continuousCount));
    },
    updateBaselineValueContinuous: (continuousAveragePrice) => {
      dispatch(setupReducer.updateBaselineValueContinuous(retId, continuousAveragePrice));
    },

    updateContinuousPercent: (continuousPercent) =>
      dispatch(setupReducer.updateContinuousPercent(retId, continuousPercent)),
    updateCurrentProfit: (currentProfit) => dispatch(setupReducer.updateCurrentProfit(retId, currentProfit)),
    updateIsBaselineRealityHammer: (isBaselineRealityHammer) =>
      dispatch(setupReducer.updateIsBaselineRealityHammer(retId, isBaselineRealityHammer))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const retId = ownProps.runId
    ? ownProps.runId
    : ownProps.isEditBlueprint
      ? ownProps.editBlueprintId
      : ownProps.optimized && ownProps.optimized.innerId !== undefined
        ? ownProps.optimized.innerId
        : id;

  const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(state, id);

  const setup = setupReducer.getSetup(state, retId);
  const projectSetup = projectReducer.getProjectSetup(state, id);

  const editBlueprintId = unifiedProjectReducer.getEditBlueprintRunId(state, id);

  const innerRunId = projectReducer.getInnerId(state, id);
  const runId = isEditBlueprint ? editBlueprintId : innerRunId !== undefined ? innerRunId : retId;

  const isOverallSegment = projectReducer.getIsOverallSegment(state, id, runId);

  return {
    isEditBlueprint: isEditBlueprint,
    setup: isEditBlueprint
      ? setupReducer.getSetup(state, editBlueprintId)
      : projectSetup && Object.keys(projectSetup).length > 2
        ? projectSetup
        : setup,
    isContinuous: setupReducer.getIsContinuous(state, runId),

    madLibs: setupReducer.getMadLibs(state, runId),
    dataset: setupReducer.getDatasetFromSetup(state, runId),
    outcomeWinRate: setupReducer.getOutcomeWinRate(state, runId),
    runId: runId,
    timePeriod: setupReducer.getTimePeriod(state, runId),
    timePeriodSelection: setupReducer.getTimePeriodSelection(state, runId),
    isOverallSegment: projectReducer.getIsOverallSegment(state, id),

    setupLabels: setupReducer.getSetupLabels(state, runId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),

    blueprint: setupReducer.getBlueprintFromSetup(state, runId),
    customMappings: setupReducer.getCustomMappings(state, runId),

    baselineCountContinuous: isOverallSegment
      ? projectReducer.getOverallContinuousCount(state, id)
      : setupReducer.getBaselineCountContinuous(state, runId),
    baselineValueContinuous: isOverallSegment
      ? projectReducer.getOverallContinuousValue(state, id)
      : setupReducer.getBaselineValueContinuous(state, runId),

    continuousPercent: setupReducer.getCurrentContinuousPercent(state, runId, id),
    continuousCurrentProfit: setupReducer.getCurrentContinuousProfit(state, runId, id),

    isBaselineRealityHammer: setupReducer.getIsBaselineRealityHammer(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RealityCheckContainer);
